import * as _ from 'lodash';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dataFilter',
})
export class DataFilterPipe implements PipeTransform {
  transform(array: any[], query: string): any {
    
    const toString = (value) => String(value ?? '');

    if (query) {
      return _.filter(array, (row) => 
        (
          toString(row?.id).toLowerCase().indexOf(query?.toLowerCase()) > -1 ||
          row.customerName?.toLowerCase().indexOf(query?.toLowerCase()) > -1 || 
          row.customerMobile?.toLowerCase().indexOf(query?.toLowerCase()) > -1 ||
          (row.customerCountryCode?.toLowerCase() + row.customerMobile?.toLowerCase()).indexOf(query?.toLowerCase().replaceAll(" ","")) > -1 ||
          ('+' + row.customerCountryCode?.toLowerCase() + row.customerMobile?.toLowerCase()).indexOf(query?.toLowerCase().replaceAll(" ","")) > -1 
          )
      );
    }
    return array;
  }
}


